var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { RemoteTrackPublication, Track, } from 'livekit-client';
import VideoElm from './videoElm';
import AudioElm from './audioElm';
import { CurrentConnectionEvents, } from '../../../helpers/livekit/types';
const ScreenShareElements = ({ currentConnection, }) => {
    _react_refresh_temp_2();
    const [screenShareTracks, setScreenShareTracks] = useState();
    useEffect(() => {
        if (currentConnection.screenShareTracksMap.size) {
            setScreenShareTracks(currentConnection.screenShareTracksMap);
        }
        currentConnection.on(CurrentConnectionEvents.ScreenShareTracks, setScreenShareTracks);
        return () => {
            currentConnection.off(CurrentConnectionEvents.ScreenShareTracks, setScreenShareTracks);
        };
    }, [currentConnection]);
    const renderElms = useMemo(() => {
        if (screenShareTracks) {
            const elm = Array();
            screenShareTracks.forEach((tracks) => {
                tracks.forEach((track) => {
                    if (track.source === Track.Source.ScreenShare) {
                        elm.push(_jsx(VideoElm, { track: track }, track.trackSid));
                    }
                    else if (track.source === Track.Source.ScreenShareAudio &&
                        track instanceof RemoteTrackPublication) {
                        // we won't add local screen share audio track to avoid eco
                        elm.push(_jsx(AudioElm, { track: track }, track.trackSid));
                    }
                });
            });
            return elm;
        }
        else {
            return null;
        }
    }, [screenShareTracks]);
    return _jsx(_Fragment, { children: renderElms !== null && renderElms !== void 0 ? renderElms : null });
};
_react_refresh_temp_1 = ScreenShareElements;
$RefreshReg$(_react_refresh_temp_1, "ScreenShareElements");
_react_refresh_temp_2(ScreenShareElements, "BvltmFdyKJHJ6cQG5LNhQudLuGM=");
export default ScreenShareElements;
